module.exports = __webpack_public_path__ + "static/media/changelog.cf02dee4.jpg";